{
  "perm": {
    "products__read": "See products",
    "products__write": "Add and change products",
    "products__publish": "Put products on / off the website",
    "catalog__read": "See the card catalog",
    "catalog__write": "Change the card catalog, categories, brands",
    "collections__read": "See collections",
    "collections__write": "Change collections",
    "import__run": "Import products from a file",
    "media__write": "Add pictures",
    "media__delete": "Delete pictures",
    "inventory__read": "See stock",
    "inventory__receive": "Receive stock",
    "inventory__adjust": "Correct stock (a reason is needed)",
    "inventory__transfer": "Move stock between shops",
    "inventory__count": "Count stock",
    "inventory__count__approve": "Approve big count differences",
    "inventory__holds__release": "Release reserved cards",
    "inventory__holds__manage": "Reserve cards by hand",
    "inventory__conflicts__resolve": "Decide when a card sold twice",
    "inventory__live_show__manage": "Run live shows",
    "listings__publish": "Put cards on marketplaces (later)",
    "channels__manage": "Connect marketplaces (later)",
    "orders__read": "See orders",
    "orders__update": "Notes, tags and e-mails on orders",
    "orders__fulfill": "Prepare and ship orders",
    "orders__cancel": "Cancel orders",
    "orders__refund": "Refund orders",
    "orders__edit": "Change address or items of an order",
    "discounts__write": "Make discount codes",
    "payments__read": "See payments",
    "payments__confirm": "Confirm bank transfers (入金確認)",
    "payments__refund": "Approve refunds, give store credit",
    "payments__reconcile": "Check card terminal statements",
    "payments__settings": "Change ways to pay and fees",
    "pos__sell": "Sell at the register",
    "pos__refund": "Refund at the register",
    "pos__void": "Cancel a register sale",
    "pos__returns": "Take returns at the register",
    "pos__open_drawer": "Open the cash drawer",
    "pos__discount_over_10": "Give more than 10% off",
    "pos__override_price": "Change a price at the register",
    "pos__shift__manage": "Open and close shifts",
    "pos__devices__pair": "Connect registers",
    "pos__hold": "Put a sale on hold",
    "pos__manual_line": "Sell an item not in the system",
    "pos__pay_out": "Take cash out of the drawer",
    "pos__shift_close_variance": "Close a shift with a cash difference",
    "pos__reports": "See register reports",
    "buylist__accept": "Buy cards from customers (買取)",
    "buylist__accept_over_limit": "Buy above the limit",
    "consignment__read": "See consignors and consigned cards",
    "consignment__manage": "Manage consignment and settlements",
    "consignment__intake": "Take in consigned cards (委託受付)",
    "consignment__price_override": "Approve big price cuts of consignors",
    "payouts__create": "Pay consignors",
    "payouts__export_bank": "Download the bank transfer file",
    "kyc__verify": "Check ID (本人確認)",
    "kyc__view": "See full ID numbers",
    "kobutsu__read": "See the 古物台帳",
    "kobutsu__export": "Download the 古物台帳",
    "customers__read": "See customers",
    "customers__write": "Change customers",
    "customers__merge": "Merge customers",
    "customers__export": "Download customer lists",
    "tax__read": "See tax reports",
    "tax__taxfree": "Tax-free sales (training needed)",
    "tax__settings": "Change tax settings",
    "cms__edit": "Edit website pages and design",
    "cms__publish": "Publish website changes",
    "settings__write": "Change shop settings",
    "settings__read": "See shop settings",
    "staff__read": "See staff",
    "staff__manage": "Add and change staff",
    "staff__roles": "Change roles",
    "api_keys__manage": "Keys for other apps",
    "reports__view": "See reports and costs",
    "reports__consignment": "See consignment reports",
    "audit__view": "See the change history",
    "audit__export": "Download the change history",
    "inbox__read": "See and do to-dos",
    "inbox__manage": "Give to-dos to others",
    "notifications__read": "See e-mails sent"
  },
  "area": {
    "products": "Products",
    "catalog": "Card catalog",
    "collections": "Collections",
    "import": "Import",
    "media": "Pictures",
    "inventory": "Stock",
    "listings": "Marketplaces",
    "channels": "Marketplaces",
    "orders": "Orders",
    "discounts": "Discounts",
    "payments": "Payments",
    "pos": "Register",
    "buylist": "Buy-ins",
    "consignment": "Consignment",
    "payouts": "Consignor payments",
    "kyc": "ID checks",
    "kobutsu": "古物台帳",
    "customers": "Customers",
    "tax": "Tax",
    "cms": "Website",
    "settings": "Settings",
    "staff": "Staff",
    "api_keys": "Other apps",
    "reports": "Reports",
    "audit": "History",
    "inbox": "To-dos",
    "notifications": "E-mails"
  },
  "list": {
    "title": "Staff",
    "intro": "Everyone who signs in to the admin or the register. Only the owner changes this page.",
    "add": "Add a staff member",
    "error": "The staff list could not be loaded.",
    "empty": "No staff yet.",
    "you": "(you)",
    "active": "Active",
    "off": "Switched off",
    "locked": "Locked after wrong passwords",
    "role": "Role",
    "shops": "Shops",
    "two_step": "Two-step sign-in",
    "pin": "Register PIN",
    "last_login": "Last sign-in",
    "on": "On",
    "set": "Set",
    "not_set": "Not set",
    "never": "Never",
    "all_shops": "Every shop",
    "a_shop": "a shop",
    "change": "Change",
    "deactivate": "Switch off",
    "reactivate": "Switch on again",
    "deactivated": "{{name}} can no longer sign in.",
    "reactivated": "{{name}} can sign in again.",
    "reset_two_step": "Reset two-step sign-in",
    "reset_pin": "Reset register PIN",
    "invited": "Invitation sent",
    "not_signed_in_yet": "Not signed in yet",
    "invite_valid": "Invitation link works until",
    "resend_invite": "Send the invitation again",
    "invite_resent": "A new invitation was e-mailed to {{email}}. The old link no longer works."
  },
  "form": {
    "add_title": "Add a staff member",
    "add_intro": "They get a temporary password and choose their own at the first sign-in.",
    "edit_title": "Change {{name}}",
    "email": "E-mail",
    "name": "Name",
    "role": "Role",
    "own_role": "You cannot change your own role.",
    "locale": "Language of the admin",
    "shops": "Shops they may work in",
    "shops_hint": "Nothing ticked = every shop.",
    "save": "Save",
    "add": "Add",
    "saved": "Staff saved.",
    "fill_all": "Enter a name, a valid e-mail and a role.",
    "created_title": "{{name}} was added",
    "created_body": "Give this temporary password to the person ({{email}}). They choose their own password at the first sign-in.",
    "created_once": "It is shown only now. If it is lost, add a new password with “Change”.",
    "created_done": "I gave the password",
    "add_intro_invite": "They get an e-mail with a link to choose their own password.",
    "delivery": "How they get in",
    "delivery_email": "Send an invitation e-mail (recommended)",
    "delivery_email_hint": "A link in their language to choose their own password. It works once.",
    "delivery_temporary_password": "Show a temporary password here instead",
    "delivery_temporary_password_hint": "For someone who cannot open e-mail right now — you give them the password.",
    "invite_done": "Done",
    "invite_sent": "An invitation was e-mailed to {{email}}. They choose their own password with the link.",
    "invite_valid": "The link works once, until",
    "invite_two_step": "Right after the password they set up two-step sign-in with an app on their phone.",
    "invite_resend_hint": "Lost or expired? Use “Send the invitation again” on the staff list."
  },
  "two_step": {
    "title": "Reset two-step sign-in of {{name}}?",
    "body": "Their authenticator app stops working for the shop; they set it up again at the next sign-in.",
    "confirm": "Reset two-step sign-in",
    "done": "Two-step sign-in of {{name}} was reset."
  },
  "locale": {
    "ja": "日本語",
    "th": "ไทย",
    "en": "English",
    "zh-Hant": "繁體中文",
    "zh-Hans": "简体中文"
  },
  "roles": {
    "title": "Roles and what they may do",
    "intro": "Each column is a role, each line something a person may do. The 6 shop roles are fixed — copy one to make your own.",
    "fixed_hint": "Fixed role — copy it to change what it may do.",
    "fixed": "Fixed role",
    "error": "The roles could not be loaded.",
    "permission": "What they may do",
    "people_one": "{{count}} person",
    "people_other": "{{count}} people",
    "copy": "Copy “{{role}}”",
    "copy_name": "{{role}} (copy)",
    "copy_title": "New role from “{{role}}”",
    "copy_intro": "The new role starts with the same ticks. Choose a name the staff understand.",
    "copy_submit": "Make the role",
    "copied": "New role made.",
    "new_name": "Name of the new role",
    "delete": "Delete",
    "delete_title": "Delete the role “{{role}}”?",
    "delete_body": "Nobody has this role. It is removed.",
    "delete_in_use_one": "{{count}} person still has this role — give them another role first.",
    "delete_in_use_other": "{{count}} people still have this role — give them another role first.",
    "deleted": "Role deleted.",
    "cell": "{{role}}: {{permission}}",
    "confirm_add": "Let “{{role}}” {{permission}}?",
    "confirm_remove": "Stop “{{role}}” from: {{permission}}?",
    "affects_one": "Affects {{count}} person. If they are signed in now, the change reaches them within {{minutes}} minutes — for it to apply at once, they sign out and sign in again.",
    "affects_other": "Affects {{count}} people. Those signed in now get the change within {{minutes}} minutes — for it to apply at once, they sign out and sign in again.",
    "confirm": "Change the role",
    "changed": "Role changed.",
    "system": {
      "owner": "Owner",
      "manager": "Manager",
      "staff": "Shop staff",
      "cashier": "Cashier",
      "content_editor": "Website editor",
      "consignment_manager": "Consignment manager"
    },
    "editable_hint": "The shop roles can be changed here, the owner role too. “Back to default” returns a role to the starting setup. A lock marks what the owner role always keeps, so the shop can never lock itself out.",
    "always_kept": "The owner role always keeps this, so the shop can never lock itself out.",
    "customized": "Changed by the shop",
    "reset": "Back to default: “{{role}}”",
    "reset_title": "Put “{{role}}” back to the starting setup?",
    "reset_body": "The ticks go back to what the role had when the shop started.",
    "reset_confirm": "Back to default",
    "reset_done": "Role back to the starting setup."
  },
  "keys": {
    "title": "Connections for other apps",
    "intro": "A key lets another program use the shop's data. Give each program its own key with only what it needs.",
    "add": "Make a key",
    "error": "The keys could not be loaded.",
    "empty": "No keys yet",
    "empty_body": "Make one only when a program asks for it.",
    "show_revoked": "Show stopped keys",
    "state_on": "Working",
    "state_paused": "Paused (its creator is switched off)",
    "state_revoked": "Stopped",
    "created_at": "Made",
    "last_used": "Last used",
    "never": "never",
    "expires": "Stops working on",
    "revoke": "Stop this key",
    "revoke_title": "Stop the key “{{name}}”?",
    "revoke_body": "The program using it stops working within a minute. This cannot be undone — make a new key if needed.",
    "revoked": "Key “{{name}}” stopped.",
    "add_title": "Make a key",
    "add_intro": "Name it after the program that uses it.",
    "name": "Name",
    "expires_optional": "Stops working on (optional)",
    "may": "What the program may do",
    "create": "Make the key",
    "fill_all": "Enter a name and tick at least one thing.",
    "created_title": "Key “{{name}}” made — copy it now",
    "created_once": "It is shown only this once. After closing this page only its first letters are shown.",
    "created_done": "I copied it"
  }
}
